import React, { useEffect, useState } from 'react'
import ListContainer from '../list';
import { getI18n, getI18nFormattedMessage } from '../../utils/intl';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from '@material-ui/core';
import { GRID_ROWS_PER_PAGE_DEFAULT_OPTION } from '../../constants';
import { useHistory } from 'react-router';
import { FormTextField } from '../../components';
import PropTypes from "prop-types";
import { fetchOrganizations } from '../../actions/organization';
import { getOrganizationsListResults, getIsLoading, getOrganizationsListTotalElements, getOrganizationsListTotalPages } from '../../reducers/organization';
import { getIsPortalAdmin } from '../../reducers/portalConfig';

const AppearanceName = ({ item }) => {
  return (
    <Link underline='none' href={`/appearance/organization/${item?.uuid}`}>{item.name}</Link>
  )
}

AppearanceName.propTypes = {
  item: PropTypes.object,
  history: PropTypes.object,
}

const getAppearanceListColumns = () => [
  {
    id: 'name',
    label: getI18nFormattedMessage("label.appearance.list.name.column.name"),
    value: (item) => <AppearanceName item={item} />,
  },
]

function AppearancePage() {

  const [organizationName, setOrganizationName] = useState("");
  const [payload, setPayload] = useState({
    name: organizationName,
    page: 0,
    size: GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
  })

  const intl = getI18n(useIntl());
  const dispatch = useDispatch();
  const appearanceListData = useSelector((state) => getOrganizationsListResults(state));
  const appearanceListTotalElements = useSelector((state) =>
    getOrganizationsListTotalElements(state));
  const appearanceListTotalPages = useSelector((state) => getOrganizationsListTotalPages(state));
  const isLoading = useSelector((state) => getIsLoading(state));

  useEffect(() => {
    dispatch(fetchOrganizations(payload));
  }, [payload]);

  const history = useHistory();

  const onEditGlobalTheme = () => {
    history.push(`/appearance/global`);
  }
  const noResultsMessage = intl.getI18nMessage("label.organization.no.results");

  const onChangePage = (newPage) => {
    if (payload.page === newPage) { return; }
    setPayload({
      ...payload,
      page: newPage,
    });
  };
  const onChangePreviousPage = () => { onChangePage(payload.page - 1); };
  const onChangeNextPage = () => { onChangePage(payload.page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setPayload({
      ...payload,
      page: 0,
      size: newRowsPerPage,
    });
  };

  const handleChange = (value) => {
    setOrganizationName(value);
  }

  const onFilterByKeyPress = (e) => {
    if (e.key === "Enter") {
      setPayload({
        ...payload,
        name: organizationName,
        page: 0,
      });
    }
  }

  const handleBlur = () => {
    setPayload({
      ...payload,
      name: organizationName,
      page: 0,
    });
  }

  const isPortalAdmin = useSelector((state) => getIsPortalAdmin(state));

  useEffect(() => {
    if(!isPortalAdmin) {
      history.push('/404')
    }
  }, [isPortalAdmin]);

  return (
    <div>
      <ListContainer
        listPageId='appearance-list-page'
        isLoading={isLoading}
        pageHeaderTitle={intl.getI18nMessage("label.appearance.title")}
        addButtonLabel={intl.getI18nMessage("label.appearance.edit.global.theme.button.text")}
        filterAndSortContent={(
          <>
            <FormTextField
              name={intl.getI18nMessage("label.filter")}
              placeholder={intl.getI18nMessage("label.organization")}
              handleChange={(value) => handleChange(value)}
              value={organizationName}
              onKeyPress={onFilterByKeyPress}
              handleBlur={handleBlur}
              id="appearance-list-org-filter"
            />
          </>
        )}
        rows={appearanceListData}
        onAdd={onEditGlobalTheme}
        columns={getAppearanceListColumns()}
        noResultsMessage={noResultsMessage}
        page={payload.page}
        totalElements={appearanceListTotalElements}
        rowsPerPage={payload.size}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        onChangePreviousPage={onChangePreviousPage}
        onChangeNextPage={onChangeNextPage}
        totalPages={appearanceListTotalPages}
      />
    </div>
  )
}

export default AppearancePage;
